import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Translation } from '../i18n/TranslationProvider';

import './Loader.scss';

const Loader = () => {
    const [showInfo, setShowInfo] = useState();

    useEffect(() => {
        // Show loader info after 3 seconds of loading
        const timeout = setTimeout(() => setShowInfo(true), 5000);

        return () => clearTimeout(timeout);
    }, []);

    return (
        <div className="loader">
            <div className="loader-container">
                <div className="loader-icon" />
                <p className="sr-only">
                    <Translation translationKey="loading" />
                </p>

                <p
                    className={classNames({
                        'loader-info': true,
                        'loader-info-show': showInfo,
                    })}
                >
                    <Translation translationKey="loadingTakesLongInfo" /><br />
                    <em><Translation translationKey="loadingTakesLongPleaseWait" /></em>
                </p>
            </div>
        </div>
    );
};

export default Loader;
